/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-southeast-2",
    "aws_cognito_region": "ap-southeast-2",
    "aws_user_pools_id": "ap-southeast-2_ebR7GOJ0Z",
    "aws_user_pools_web_client_id": "5dgljvhj1dq2gosillh30dv941",
    "oauth": {}
};


export default awsmobile;
